// API configuration for frontend
// In development, use proxy (/api) to avoid CORS issues
// In production, use the full backend URL from environment variable
const getApiBaseUrl = () => {
  // If environment variable is set, use it
  // IMPORTANT: REACT_APP_API_URL should NOT include /api suffix
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
    return cleanUrl.endsWith('/api') ? cleanUrl : `${cleanUrl}/api`;
  }

  // In production (Vercel) or development, use proxy/rewrite
  // The Vercel rewrite rule in vercel.json will forward /api/* to Railway backend
  // This makes requests appear same-origin, allowing cookies to work
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

// Debug logging
console.log('[Merchant App - utils] API_BASE_URL:', API_BASE_URL);
console.log('[Merchant App - utils] REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

export const apiCall = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`;

  // Don't set Content-Type for FormData - browser sets it with boundary automatically
  const isFormData = options.body instanceof FormData;

  const defaultOptions = {
    credentials: 'include',
    headers: isFormData ? {} : {
      'Content-Type': 'application/json',
    },
  };

  // Merge headers properly
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  const response = await fetch(url, mergedOptions);
  return response;
};

// Export apiFetch as an alias for backward compatibility
export const apiFetch = apiCall;

export default apiCall;